import {Component, OnInit, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {SessionService} from 'src/app/services/session.service';
import {TrustiiService} from 'src/app/services/trustii.service';
import {DataService} from 'src/app/services/data.service';
import {DialogService} from 'src/app/services/dialog.service';

@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.scss']
})
export class ResetComponent implements OnInit, OnDestroy {
  reset = false;

  // Form var
  firstName = '';
  lastName = '';
  oldPassword = '';
  newPassword = '';
  repeatNewPassword = '';

  // Error var
  passwordSameError = false;
  passwordEmptyError = false;
  firstnameEmptyError = false;
  lastnameEmptyError = false;
  passwordNotStrongEnough = false;
  resetFailed = false;
  resetInProgress = false;

  // password strength display var
  bar0: string;
  bar1: string;
  bar2: string;
  bar3: string;
  private colors = ['darkred', 'orangered', 'orange', 'yellowgreen'];

  constructor(private router: Router, private sessionService: SessionService, private trustiiService: TrustiiService,
              private dataservice: DataService, private dialogService: DialogService) {
    document.body.style.backgroundImage = 'url("/assets/img/TrustiiHomePage.png")';
    document.body.style.backgroundPosition = 'center center';
    document.body.style.backgroundRepeat = 'no-repeat';
    document.body.style.backgroundAttachment = 'fixed';
    document.body.style.backgroundSize = 'cover';
  }

  ngOnInit() {
    const token = localStorage.getItem('token');
    if (!token) {
      this.goHome();
    }
    this.firstName = this.sessionService.getUser().firstname;
    this.lastName = this.sessionService.getUser().lastname;
  }

  resetPassword(e) {
    this.passwordEmptyError = false;
    this.passwordNotStrongEnough = false;
    this.passwordSameError = false;

    if (this.firstName.length < 1) {
      this.firstnameEmptyError = true;
    }
    if (this.lastName.length < 1) {
      this.lastnameEmptyError = true;
    }
    if (this.oldPassword.length < 1) {
      this.passwordEmptyError = true;
    }
    if (this.newPassword !== this.repeatNewPassword) {
      this.passwordSameError = true;
    }
    if (this.scorePassword(this.newPassword) < 100) {
      this.passwordNotStrongEnough = true;
    }

    if (this.firstnameEmptyError || this.lastnameEmptyError ||
      this.passwordSameError || this.passwordEmptyError || this.passwordNotStrongEnough) {
      return;
    }
    this.resetInProgress = true;

    this.trustiiService.resetPassword(
      this.oldPassword,
      this.newPassword,
      this.repeatNewPassword,
      this.firstName,
      this.lastName
    ).subscribe(
      (res) => {
        this.dataservice.setData({resetPassword: false});
        this.resetInProgress = false;
        this.dialogService.openAlertDialog(
          '350px',
          'Your account is now activated, please login in',
          'SUCCESS',
          'Ok',
          'modal-informative'
        );
        this.goHome();
      },
      (err) => {
        this.resetFailed = true;
        this.resetInProgress = false;
      }
    );
  }

  scorePassword(password: string): number {
    let score = 0;
    if (!password) {
      return score;
    }

    const digits = /\d/;
    if (digits.test(password)) {
      score += 20;
    }

    const lower = /[a-z]/;
    if (lower.test(password)) {
      score += 20;
    }

    const upper = /[A-Z]/;
    if (upper.test(password)) {
      score += 20;
    }

    const noWords = /\W/;
    if (noWords.test(password)) {
      score += 20;
    }

    if (password.length >= 8) {
      score += 20;
    }

    return score;
  }

  changePassword(password: string): void {
    this.setBarColors(4, '#DDD');
    if (password) {
      const c = this.getColor(this.scorePassword(password));
      this.setBarColors(c.index, c.color);
    }
  }

  private getColor(s) {
    let index = 0;
    if (s < 40) {
      index = 0;
    } else if (s < 70) {
      index = 1;
    } else if (s < 100) {
      index = 2;
    } else if (s === 100) {
      index = 3;
    } else {
      index = 4;
    }
    return {
      index: index + 1,
      color: this.colors[index]
    };
  }

  private setBarColors(count, col) {
    for (let n = 0; n < count; n++) {
      this['bar' + n] = col;
    }
  }

  goHome() {
    this.router.navigateByUrl('', {skipLocationChange: false});
  }

  ngOnDestroy() {
    document.body.style.backgroundImage = '';
  }
}
